/** The PUT /annie/avatar body's `kind` for the standard look (no design). Never stored or returned. */
export enum AnnieAvatarSaveKind {
	Standard = "standard",
}
